module.exports = __webpack_public_path__ + "static/team-6-aa49a4316b4c037f54f6132bfeaf1716.jpg";